import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import axios from 'axios';
import { API_CALL_STATUS } from '../../../reducers/status';
import { setBranchCodesApiStatus } from '../../../actions/kaMetlhaFuneralClaim/referenceData';
import { getUploadDocumentsSummary } from '../../../selectors/kaMetlhaFuneralClaim/uploadDocuments';
import { getClaimentDetailsForm, getClaimentDetailsSummary } from '../../../selectors/kaMetlhaFuneralClaim/claimentDetails';
import { getDeceasedDetailsSummary, getDecesedId } from '../../../selectors/kaMetlhaFuneralClaim/deceasedDetails';
import { getReferenceNumber } from '../../../selectors/kaMetlhaFuneralClaim/referenceData';

export const claimMailService = (store, next, action) => {
    const state=store.getState();
    (async () => {
        try{
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.PENDING,apiFor:'finalEmail'}))
            const {firstName,middleName,lastName,mobileNumber,email,policyNumber}= getClaimentDetailsForm(state)
            const decesedId=getDecesedId(state)
            const buyRef=action?.value
            const productLabel='Ka-Metlha-Funeral-Claim'
            // const monthlyQuoteAllproducts = getFinalQuotation(state)
            const referenceNumber=policyNumber?.value
            // const premiumFrequency = 'Monthly'
            const claimentDetails=getClaimentDetailsSummary(state) 
            const deceasedDetails=getDeceasedDetailsSummary(state) 
            const uploadDocuments=getUploadDocumentsSummary(state)
        const claimSummary = [
            { title: 'Claiment Details', data: claimentDetails },
            { title: 'Deceased Details', data: deceasedDetails },
            {title: 'Documents',data:uploadDocuments},
        ];
        const userDataFields = [...claimSummary]

        const sampleRequestBody = {
            firstName:firstName?.value,
            lastName:lastName?.value,
            contactNumber:mobileNumber?.value,
            subject:`Web: ${productLabel} : ${firstName?.value+' '+lastName?.value} - REF: ${decesedId?.value}`,
            userDataFields,
            templateType:"FUNERAL_CLAIM_BUISENESS",
            // "FUNERAL_CLAIM_BUISENESS",
            // FUNERAL_PURCHASE_BUISENESS
            monthlyPremium: null,
            yearlyPremium:null,
            email:"BW_KMF_BUSSINESS_MAIL",
        }
       
        const sampleRequestCustomer = {
            firstName:firstName?.value,
            lastName:lastName?.value,
            contactNumber:mobileNumber?.value,
            subject:`Web: ${productLabel} : ${firstName?.value+' '+lastName?.value} - REF: ${decesedId?.value}`,
            userDataFields,
            templateType:"FUNERAL_CLAIM_CUSTOMER",
            monthlyPremium: null,
            yearlyPremium:null,
            email:email?.value,
        }
        const response = await sendEmailNotification(sampleRequestBody);
        const responseCustomer = await sendEmailNotification(sampleRequestCustomer);
        if (response && response.status === httpStatusCode.OK) {
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.SUCCESS,apiFor:'finalEmail'}));
        } else {
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.FAILURE,apiFor:'finalEmail'}));
        }
    }
        catch(error){
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.FAILURE,apiFor:'finalEmail'}));
        }
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            url: 'om-api/submit-notification/submitNotificationEmail',
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};